import { SVGProps, useId } from 'react'

type CyberSecMarkProps = SVGProps<SVGSVGElement> & { title?: string }

export default function CyberSecMark({ title = 'CyberSec mark', ...props }: CyberSecMarkProps) {
  const rawId = useId()
  const maskId = `${rawId}-mask`
  const titleId = `${rawId}-title`

  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
        <rect width="64" height="64" fill="#fff" />
        <path
          d="M44 19c-9.941 0-18 8.059-18 18s8.059 18 18 18h6"
          fill="none"
          stroke="#000"
          strokeWidth="8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <path
        d="M32 4 12 12v18c0 12.96 8.927 24.73 20 28 11.073-3.27 20-15.04 20-28V12L32 4Z"
        fill="currentColor"
        mask={`url(#${maskId})`}
      />
    </svg>
  )
}
